<ng-container *appTranslate="let t">
  <app-progress-bar [progressid]="progressId" [initialMessage]="initialMessage" />

  <div *ngIf="cancelable" class="flex justify-content-center mt-4">
    <app-button
      [label]="t('common.cancel')"
      icon="pi pi-times"
      class="p-button-warning"
      (onClick)="cancel()"
    ></app-button>
  </div>
</ng-container>
